import { ref } from 'vue';
import axios from 'axios';

const isEmailModalActive = ref(false);
const emailTemplates = ref([]);
const emailTemplateNameIdPairs = ref([]);
const emailTemplate = ref({
  body: '',
  emailTemplateId: 0,
  emailTemplateName: '',
  subject: '',
  from: '',
  to: [],
  cc: [],
  bcc: [],
  isManualSend: false,
  blobGeneralId: 0,
  emailTemplateType: '',
  sendTestTo: 'housing@digipen.edu',
  sessionName: '',
  autoEmailModule: '',
});

export default function useEmailTemplate() {
  const resetCurrentEmailTemplate = async () => {
    emailTemplate.value = {
      emailTemplateId: 0,
      emailTemplateType: '',
      body: '',
      from: '',
      to: [],
      cc: [],
      bcc: [],
      autoEmailModule: '',
      blobGeneralId: 0,
      sendTestTo: 'housing@digipen.edu',
      sessionName: '',
      subject: '',
    };
  };

  const convertStringEmailsToArray = () => {
    if (typeof emailTemplate.value.bcc === 'string' || emailTemplate.value.bcc instanceof String) {
      emailTemplate.value.bcc = emailTemplate.value.bcc.split(/[\s,]+/);
    }
    if (typeof emailTemplate.value.cc === 'string' || emailTemplate.value.cc instanceof String) {
      emailTemplate.value.cc = emailTemplate.value.cc.split(/[\s,]+/);
    }
    if (typeof emailTemplate.value.to === 'string' || emailTemplate.value.to instanceof String) {
      emailTemplate.value.to = emailTemplate.value.to.split(/[\s,]+/);
    }
  };

  const createEmailTemplate = async () => {
    try {
      convertStringEmailsToArray();
      const result = await axios.post(`${process.env.VUE_APP_HOUSING_SERVICE_URL}/api/emails`, emailTemplate.value);

      return result;
    } catch (error) {
      console.log(error);
      return error.response;
    }
  };

  const deleteEmailTemplate = async (id) => {
    try {
      const result = await axios.delete(`${process.env.VUE_APP_HOUSING_SERVICE_URL}/api/emails`,
        {
          params: {
            emailTemplateId: id,
          },
        });

      return result;
    } catch (error) {
      console.log(error);
      return error.response;
    }
  };

  const sendTestEmail = async () => {
    try {
      convertStringEmailsToArray();
      const result = await axios.post(`${process.env.VUE_APP_HOUSING_SERVICE_URL}/api/emails/SendTestEmail`, emailTemplate.value);

      return result;
    } catch (error) {
      console.log(error);
      return error.response;
    }
  };

  const getEmailTemplate = async (id) => {
    try {
      if (!id) {
        return null;
      }
      const url = `${process.env.VUE_APP_HOUSING_SERVICE_URL}/api/emails/${id}`;
      const response = await axios.get(url);
      const { data } = response;

      emailTemplate.value = data;
      return data;
    } catch (error) {
      console.log(error);
    }

    return null;
  };

  const getEmailTemplateNameIdPairs = async () => {
    try {
      const url = `${process.env.VUE_APP_HOUSING_SERVICE_URL}/api/emails/getEmailTemplateNameIdPairs`;
      const response = await axios.get(url);
      const { data } = response;
      emailTemplateNameIdPairs.value = data.data;
      return data.data;
    } catch (error) {
      console.log(error);
    }

    return null;
  };

  const getAllEmailTemplates = async () => {
    try {
      const url = `${process.env.VUE_APP_HOUSING_SERVICE_URL}/api/emails/`;
      const response = await axios.get(url);
      const { data } = response;
      emailTemplates.value = data;
      return data;
    } catch (error) {
      console.log(error);
    }

    return null;
  };

  const getManualEmailList = async () => {
    try {
      const url = `${process.env.VUE_APP_HOUSING_SERVICE_URL}/api/emails/GetManualEmailList`;
      const response = await axios.get(url);
      const { data } = response;
      return data.data;
    } catch (error) {
      console.log(error);
      return error.resposne;
    }
  };

  const getExampleEmail = async (emailTemplateName, email, sessionId) => {
    try {
      const url = `${process.env.VUE_APP_HOUSING_SERVICE_URL}/api/emails/GetExampleEmail`;
      const response = await axios.get(url, {
        params: {
          emailTemplateName,
          email,
          sessionId,
        },
      });

      return response;
    } catch (error) {
      console.log(error);
      return error.response;
    }
  };

  const updateEmailTemplate = async () => {
    try {
      convertStringEmailsToArray();
      const result = await axios.put(`${process.env.VUE_APP_HOUSING_SERVICE_URL}/api/emails/`, emailTemplate.value);

      return result;
    } catch (error) {
      console.log(error);
      return error.response;
    }
  };

  const updateEmailTemplateName = (val) => {
    emailTemplate.value.from = 'housing@digipen.edu';
    emailTemplate.value.to = 'Student_Email';
    emailTemplate.value.sendTestTo = 'housing@digipen.edu';
    emailTemplate.value.bcc = 'housing@digipen.edu';
    if (val === 'DssRequestedToDss') {
      emailTemplate.value.to = 'dss@digipen.edu';
    }
    if (val === 'ApplicationSubmittedToHousing') {
      emailTemplate.value.to = 'housing@digipen.edu';
    }
  };

  const populateEmailList = async () => {
    try {
      const url = `${process.env.VUE_APP_HOUSING_SERVICE_URL}/api/emails/GetApplicantEmailList`;
      const response = await axios.get(url);
      const { data } = response;
      return data.data;
    } catch (error) {
      console.log(error);
      return error.response;
    }
  };

  const sendManualEmails = async (emailList, emailTemplateName, sessionId) => {
    try {
      const sendManaualEmailsModel = {
        emailList,
        emailTemplateName,
        sessionId,
      };
      const url = `${process.env.VUE_APP_HOUSING_SERVICE_URL}/api/emails/SendManualEmails`;
      const response = await axios.post(url, sendManaualEmailsModel);
      return response;
    } catch (error) {
      console.log(error);
      return error.response;
    }
  };

  const generateSystemEmailTemplates = async () => {
    try {
      const url = `${process.env.VUE_APP_HOUSING_SERVICE_URL}/api/emails/GenerateSystemEmailTemplates`;
      const response = await axios.post(url, {});
      return response;
    } catch (error) {
      console.log(error);
      return error.response;
    }
  };

  return {
    deleteEmailTemplate,
    emailTemplate,
    emailTemplates,
    emailTemplateNameIdPairs,
    createEmailTemplate,
    getEmailTemplate,
    getEmailTemplateNameIdPairs,
    getExampleEmail,
    getAllEmailTemplates,
    getManualEmailList,
    isEmailModalActive,
    populateEmailList,
    updateEmailTemplate,
    updateEmailTemplateName,
    resetCurrentEmailTemplate,
    sendManualEmails,
    sendTestEmail,
    generateSystemEmailTemplates,
  };
}
